let baseURL = "https://apiob.regionsanmartin.gob.pe";

if (process.env.NODE_ENV === "production")
  baseURL = "https://apiob.regionsanmartin.gob.pe";

export default baseURL;
